import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import { Accordions, Accordion } from '../Accordions';

import {
  Wrapper,
  StyledContainer,
  Intro,
  ImageWrapper,
  FAQImg,
} from './styles';

const FAQs = ({ sectionId, data }) => {
  const { titleHtml, imageLogoSharp, imageFAQ, imageFAQSharp, items } = data;

  return (
    <Wrapper id={sectionId}>
      <StyledContainer className="auto-margin">
        <Intro imageLogo={imageLogoSharp.publicURL}>
          {ReactHtmlParser(titleHtml)}
          <ImageWrapper>
            {imageFAQ && <FAQImg src={imageFAQSharp} alt={imageFAQ.altTag} />}
          </ImageWrapper>
        </Intro>
        <Accordions>
          {items.map(({ questionHtml, answerHtml }, index) => {
            return (
              <Accordion
                html={questionHtml}
                key={`faqs-accordion-${index.toString()}`}
              >
                {ReactHtmlParser(answerHtml)}
              </Accordion>
            );
          })}
        </Accordions>
      </StyledContainer>
    </Wrapper>
  );
};

FAQs.propTypes = {
  data: PropTypes.shape().isRequired,
  sectionId: PropTypes.string.isRequired,
};

FAQs.defaultProps = {};

export default FAQs;
